import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, UsersIcon } from 'lucide-react';
import type { WebsiteContent } from '../../data/website';
interface AboutSectionProps {
  content: WebsiteContent;
}

/** Homepage teaser. The full story, credits, and endorsements live at /about. */
export function AboutSection({
  content
}: AboutSectionProps) {
  const paragraphs = content.aboutBody.split('\n').map(line => line.trim()).filter(Boolean);
  const lead = paragraphs.slice(0, 2);
  const venues = content.aboutVenues.filter(venue => venue.venue.trim()).slice(0, 4);
  if (!lead.length) return null;
  return <section id="about" className="scroll-mt-4 border-t border-white/[0.08] bg-[#100d0b] px-5 py-14 sm:px-8 sm:py-20" aria-labelledby="about-heading" data-id="element-870" data-mp="gdpiq860lh51">
      <div className="mx-auto grid max-w-5xl gap-9 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:items-center lg:gap-14" data-id="element-871" data-mp="3k0g5oevkjj5w">
        <div data-id="element-872" data-mp="3f1lkj6a4piim">
          {content.aboutEyebrow.trim() && <div className="mb-3 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#e8a369]" data-id="element-873" data-mp="1u3l9jjruyk9w">
              <UsersIcon className="h-3.5 w-3.5" data-id="element-874" data-mp="1z0le1q927eyw" /> {content.aboutEyebrow}
            </div>}
          <h2 id="about-heading" className="font-serif-display text-[40px] leading-[1.02] text-white sm:text-[52px]" data-id="element-875" data-mp="23tej6f8fwpbi">
            {content.aboutTitle || 'About the band'}
          </h2>

          <div className="mt-6 space-y-4" data-id="element-876" data-mp="1b5iofg2fl7hd">
            {lead.map(paragraph => <p key={paragraph.slice(0, 40)} className="max-w-[62ch] text-[15px] leading-relaxed text-[#e7d5c7]/80" data-id="element-877" data-mp="1g4d6gfskqs0f">
                {paragraph}
              </p>)}
          </div>

          {venues.length > 0 && <p className="mt-6 text-[13px] text-zinc-500" data-id="element-878" data-mp="1p5bd75ueddmp">
              Played {venues.map(venue => venue.venue).join(' · ')}
            </p>}

          <Link to="/about" className="mt-7 inline-flex items-center gap-1.5 rounded-sm border border-[#e8a369]/70 px-4 py-2.5 text-[12px] font-bold uppercase tracking-[0.07em] text-[#f5c194] transition-colors duration-150 ease-out hover:bg-[#e08d59] hover:text-[#24130b] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e8a369]" data-id="element-879" data-mp="30im3jjxbosdu">
            Read the full story <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-880" data-mp="15fqw8khkfcvo" />
          </Link>
        </div>

        {content.aboutImageUrl.trim() && <img src={content.aboutImageUrl} alt={content.aboutImageAlt || `${content.bandName} Texas country live performance`} loading="lazy" className="h-auto w-full rounded-sm object-contain" data-id="element-881" data-mp="hqxta42j04rk" />}
      </div>
    </section>;
}